export default "__VITE_ASSET__BOjFmkT6__"